module.exports = __webpack_public_path__ + "static/legacy_card_img2@2x-c5ec937042edc2fd3b4d27a53b4b8e98.png";